import { render, staticRenderFns } from "./UpdateProduct.vue?vue&type=template&id=97ff6628&"
import script from "./UpdateProduct.vue?vue&type=script&lang=js&"
export * from "./UpdateProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports